const React = require('react');
const { default: TextField } = require('@mui/material/TextField');

const internals = {};

internals.toDateInputValue = (value) => {

    if (!value) {
        return '';
    }

    if (typeof value === 'string') {
        return value.slice(0, 10);
    }

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return value.toISOString().slice(0, 10);
    }

    return '';
};

module.exports = function ControlledDateField(props) {

    const {
        id,
        label,
        value,
        onBlur,
        onChange,
        onFocus,
        textFieldProps = {}
    } = props;

    return <TextField
        id={id}
        label={label}
        type='date'
        value={internals.toDateInputValue(value)}
        onBlur={onBlur}
        onChange={(event) => {

            if (typeof onChange === 'function') {
                onChange(event.target.value, event);
            }
        }}
        onFocus={onFocus}
        InputLabelProps={textFieldProps.InputLabelProps || {}}
        fullWidth
        {...textFieldProps}
    />;
};

module.exports.internals = internals;
